var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tos" }, [
    _c("div", { staticClass: "signup-tos" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.accepted,
            expression: "accepted",
          },
        ],
        attrs: {
          type: "checkbox",
          id: "signupTosChecked",
          name: "signupTosChecked",
        },
        domProps: {
          checked: Array.isArray(_vm.accepted)
            ? _vm._i(_vm.accepted, null) > -1
            : _vm.accepted,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.accepted,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.accepted = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.accepted = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.accepted = $$c
              }
            },
            _vm.emit,
          ],
        },
      }),
      _vm._v(" "),
      _c("p", [
        _vm._v("Hyväksyn palvelun "),
        _c("a", { on: { click: _vm.openTos } }, [_vm._v("käyttöehdot")]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "modal",
          {
            attrs: {
              name: "signup-tos",
              adaptive: true,
              scrollable: true,
              reset: true,
              width: "60%",
              height: "auto",
            },
            on: { "before-open": _vm.fetchTos },
          },
          [
            _c("div", { staticClass: "modal__content" }, [
              _c("div", {
                staticClass: "tos",
                domProps: { innerHTML: _vm._s(_vm.signupTosContent) },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "modal__footer" }, [
                _c("span", { on: { click: _vm.rejectTos } }, [
                  _vm._v("En hyväksy"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--call-to-action btn--small",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.acceptTos.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n                        OK\n                    ")]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }